import PropTypes from "prop-types";

export let SectorLevelPropTypes = PropTypes.exact({
  type: PropTypes.oneOf(["NAICS", "SIC"]),
  code: PropTypes.number,
  description: PropTypes.string,
  likelihood: PropTypes.number
})